import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslocoPipe } from '@jsverse/transloco';
import { Store } from '@ngxs/store';
import { CookieService } from 'ngx-cookie-service';

import { UiPlatformButtonComponent, UiPlatformSwitchComponent } from 'ui-platform';

import { CookieSettingsService } from './services/cookie-settings.service';

import { environment } from '../../../../environments/environment';
import { CookiesSettingsSet } from '../../state/app.actions';
import { AppState, CookiesSettings, SH_COOKIE_CONSENT_SETTINGS } from '../../state/app.state';

@Component({
  selector: 'sh-cookies-settings',
  imports: [
    NgIf,
    ReactiveFormsModule,
    TranslocoPipe,
    UiPlatformButtonComponent,
    UiPlatformSwitchComponent,
    FormsModule
  ],
  templateUrl: './cookies-settings.component.html',
  styleUrl: './cookie-settings.component.scss'
})
export class CookiesSettingsComponent {
  readonly #store = inject(Store);
  readonly #cookieService = inject(CookieService);
  readonly #cookieSettingsService = inject(CookieSettingsService);

  cookiesSettings$ = this.#store.select(AppState.getCookiesSettings);

  isNecessaryChecked = true;
  isMarketingChecked = false;
  isAnalyticalChecked = false;

  #areCookieSettingsEnabled = false;

  public get areCookieSettingsEnabled(): boolean {
    return this.#areCookieSettingsEnabled;
  }

  public get cookieBannerTitle(): string {
    return this.#areCookieSettingsEnabled ? 'cookie.banner.settings.title' : 'cookie.banner.title';
  }

  public get isCookieAgreed(): boolean {
    return this.#cookieSettingsService.isCookieAgreed;
  }

  constructor() {
    // if cookie settings changes -> refresh cookie settings
    this.cookiesSettings$.pipe(takeUntilDestroyed()).subscribe((cookiesSettings: CookiesSettings) => {
      this.#cookieSettingsService.handleCookies(cookiesSettings);
    });
  }

  toggleCookieSettings(): void {
    this.#areCookieSettingsEnabled = !this.#areCookieSettingsEnabled;
  }

  /**
   * Save of cookies (button click)
   */
  acceptCookieLaw(acceptAll = false, onlyNecessary = false): void {
    const cookiesSettings = {
      necessaryCookies: true,
      marketingCookies: acceptAll ? true : onlyNecessary ? false : this.isMarketingChecked,
      analyticalCookies: acceptAll ? true : onlyNecessary ? false : this.isAnalyticalChecked
    } as CookiesSettings;

    // save cookies settings to, well, cookie
    this.#cookieService.set(
      SH_COOKIE_CONSENT_SETTINGS,
      JSON.stringify(cookiesSettings),
      new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 90),
      '/',
      undefined,
      environment.cookies_secure
    );
    this.#store.dispatch(new CookiesSettingsSet(cookiesSettings));
  }
}
